// Dependencies
import React, { useState } from "react";
import FetchSpinner from "../../components/FetchSpinner";
import FetchSpinnerContext from "./FetchSpinnerContext";

const FetchSpinnerProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);

  const initFetch = () => setLoading(true);
  const endFetch = () => setLoading(false);

  return (
    <FetchSpinnerContext.Provider value={{ initFetch, endFetch }}>
      <FetchSpinner
        children={children}
        loading={loading}
        text="Sincronizando datos con el servidor ..."
      />
    </FetchSpinnerContext.Provider>
  );
};

export default FetchSpinnerProvider;
